import { render, staticRenderFns } from "./BackendTranslatedEntityPlainText.vue?vue&type=template&id=6f68bfa0&scoped=true&"
import script from "./BackendTranslatedEntityPlainText.vue?vue&type=script&lang=js&"
export * from "./BackendTranslatedEntityPlainText.vue?vue&type=script&lang=js&"
import style0 from "./BackendTranslatedEntityPlainText.vue?vue&type=style&index=0&id=6f68bfa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68bfa0",
  null
  
)

export default component.exports